import { Component, Injectable, Input, Compiler,OnInit } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons,NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupService } from '../../../../../app/services/group.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { LoadingComponent } from '../../../../../app/home/paraEmpresas/modalLoading/content.component';
import { AuthenticationService } from '../../../../../app/services/authentication.service';

/**
 * @version $Id: content.component.ts 70114 2017-11-17 20:07:29Z diego.s.bastos $
 */
@Component({
  selector: 'removeGroupConsume',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class RemoveGroupConsumeComponent  implements OnInit {

  @Input() group: DataPackGroup;
  private saving: boolean;
  private isData: boolean;

  constructor(private authenticationService: AuthenticationService,private modalService: NgbModal,private bindComponent:BindComponentService,private activeModal: NgbActiveModal, private groupService: GroupService, private alertService: AlertService) {

  }

  ngOnInit() {
    let data  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.isData = data['isData'];
  }

  private close() {
    this.activeModal.dismiss();
  }
  private openModalLoading() {
      this.modalService.open(LoadingComponent,{       backdrop: 'static',       keyboard: false ,     });
  }

  private remove() {
   this.openModalLoading();

  
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,true);
    this.saving = true;
    this.group.isData = this.isData;
    let payload: any = {};
    payload.action = 'remove';
    payload.hasDataService = this.isData;
    payload.group = this.group;
    this.groupService.remove(payload).subscribe(
      data => {
        this.activeModal.close();
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION,true);
         this.alertService.success(data['result']);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.activeModal.close();
        this.alertService.error(err.result, err);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/remove/content.component.ts